import React  from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import {
    withStyles, TextField, Button,
    FormControl,
    InputLabel,
    Select,
    OutlinedInput,
    MenuItem,
    ListItemText,
    Chip,
    Checkbox, 
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel
} from '@material-ui/core'
// import {
//     stateToHTML
// } from 'draft-js-export-html'
import YomaEditor from '../../components/YomaEditor'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import {
    CURRENCY_TYPE,
    BENEFITS
} from '../../utils/CommonConstant'
import MomentUtils from '@date-io/moment'
import {
    InlineDatePicker,
    MuiPickersUtilsProvider
} from 'material-ui-pickers'
import '../../assets/css/datePicker.css'
import { 
    defaultFont
} from '../../assets/jss/common-style'


let CreateJobForm = (props) => {

    const { 
        handleSubmit, 
        classes, 
        entities, 
        categories, 
        contract,
       // initialValues: {benefits,category},
        selectedCategory,
        handleChangeCategory,
        selectedBenefit,
        handleChangeBenefit,
        handleChangeDescription,
        handleChangeRequirment,
        error_category,
        error_benefit,
        error_description,
        error_requirment
    } = props

    return (
        <form className={classes.main}>
            <GridContainer>
                <GridItem xs={12} sm={6} md={6}>
                    <Field
                        style={classes.input}
                        name="title"
                        component={renderField}
                        type="text"
                        label="Position Title"
                    />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                    <Field
                        style={classes.input}
                        name="entity"
                        component={renderSelect}
                        type="text"
                        label="Entity"
                        label_width={50}
                    >

                        <MenuItem value="Select Entity"/>
                        {
                            Object.keys(entities).map((item, key) => 
                                <MenuItem value={item} key={key}>
                                    {item}
                                </MenuItem>
                            )
                        }

                    </Field>
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <FormControl
                        fullWidth  
                        variant="outlined" 
                        className={classes.select}
                        error={error_category}>
                        <InputLabel htmlFor="local_benefit">
                           Job Category
                        </InputLabel>
                        <Select
                            fullWidth
                            multiline
                            onChange={(event) => handleChangeCategory(event.target.value)}
                            input={<OutlinedInput id="local_benefit" labelWidth={100}/>}
                            value={selectedCategory}
                            renderValue={ selected => (
                                <div>
                                    {
                                         selected.map( (value, key) => (
                                           <Chip key={key} label={value} color="secondary" />
                                         ))
                                    }
                                </div>
                            )}
                        >
                            {
                                Object.keys(categories).map( (benefit, key) => (
                                    
                                    <MenuItem key={key} value={benefit}>

                                        <Checkbox checked={selectedCategory.indexOf(benefit) > -1 } />
                                        
                                        <ListItemText primary={benefit}/>
                                    </MenuItem>

                                ))
                            }
                        </Select>
                    </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>

                    <FormControl 
                        fullWidth  
                        variant="outlined" 
                        className={classes.select}
                        error={error_benefit}>
                        <InputLabel htmlFor="local_benefit">
                            Local Benefits
                        </InputLabel>
                        <Select
                            fullWidth
                            multiline
                            onChange={(event) => handleChangeBenefit(event.target.value)}
                            input={<OutlinedInput id="local_benefit" labelWidth={100}/>}
                            value={selectedBenefit}
                            renderValue={ selected => (
                                <div>
                                    {
                                         selected.map( (value, key) => (
                                           <Chip key={key} label={value} color="secondary"/>
                                         ))
                                    }
                                </div>
                            )}
                        >
                            {
                                BENEFITS.map( (benefit, key) => (
                                    
                                    <MenuItem key={key} value={benefit}>

                                        <Checkbox checked={selectedBenefit.indexOf(benefit) > -1 } />
                                        
                                        <ListItemText primary={benefit}/>
                                    </MenuItem>

                                ))
                            }
                        </Select>
                    </FormControl>
                    
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        style={classes.input}
                        name="contract"
                        label="Job Type"
                        component={renderRadioGroup}
                    >
                        <FormControlLabel
                            label="Full Time"
                            value="full"
                            control = {
                                <Radio  color="secondary"/>
                            }
                        />

                        <FormControlLabel
                            label="Part Time"
                            value="part"
                            control = {
                                <Radio  color="secondary"/>
                            }
                        />

                        <FormControlLabel
                            label="Fixed Term"
                            value="fixed"
                            control = {
                                    <Radio  color="secondary"/>
                            }
                        />
                    </Field>
                </GridItem>

                {
                    checkContract(contract) && (
                        <GridItem xs={12} sm={6} md={6}>
                            <Field
                                name="start_date"
                                label="Start Date"
                                placeholder="If Fixed Term, specify period"
                                component={renderDatePicker}
                                className="date-picker"
                            />
                        </GridItem>
                    )
                }

                {
                    checkContract(contract) && (
                        <GridItem xs={12} sm={6} md={6}>
                            <Field
                                name="end_date"
                                label="End Date"
                                placeholder="If Fixed Term, specify period"
                                component={renderDatePicker}
                                className="date-picker"
                            />
                        </GridItem>
                    )
                }

                <GridItem xs={12} sm={6} md={6}>
                    <Field
                        style={classes.input}
                        name="department"
                        component={renderField}
                        type="text"
                        label="Department"
                    />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                    <Field
                        style={classes.input}
                        name="location"
                        component={renderField}
                        type="text"
                        label="Location"
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={5}>
                    <Field
                        style={classes.input}
                        name="min_salary"
                        component={renderField}
                        type="number"
                        label="From (Gross Salary)"
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    <Field
                        style={classes.input}
                        name="max_salary"
                        component={renderField}
                        type="number"
                        label="To (Gross Salary)"
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                    <Field
                        style={classes.input}
                        name="currency_type"
                        component={renderSelect}
                        label="Currency"
                        label_width={75}
                    >
                        {
                            CURRENCY_TYPE.map(( currency, key) => 
                                <MenuItem key={key} value={currency}>
                                    <ListItemText primary={currency}/>
                                </MenuItem>
                            )
                        }
                    
                    </Field>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    {/* <Field
                        style={classes.input}
                        name="description"
                        component={renderEditor}
                        type="text"
                        label="Job Description"
                    /> */}
                    <div>
                    <YomaEditor placeholder="Job Requirement" onChange={handleChangeRequirment} />
                    {   
                        error_requirment && <span style={{ color: "red" }}>This field is reuired!</span>
                    }
                    </div>
                    
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    {/* <Field
                        style={classes.input}
                        name="requirements"
                        component={renderEditor}
                        type="text"
                        label="Job Requirment"
                    /> */}
                    <div>
                    <YomaEditor placeholder="Job Description" onChange={handleChangeDescription} />
                    {   
                        error_description && <span style={{ color: "red" }}>This field is reuired!</span>
                    }
                    </div>
                    
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="close_date"
                        component={renderDatePicker}
                        label="Target date for Commencement"
                        className="date-picker"
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Button 
                        style={styles.createButton} 
                        onClick={handleSubmit} 
                        variant="contained" 
                        color="secondary"
                        component="span">
                        Create
                    </Button>
                </GridItem> 
            </GridContainer>
        </form>
    )

}

CreateJobForm.propTyupes = {
    classes: PropTypes.object.isRequired
}

const styles = ({
    main: {
        width: "75%",
        marginTop: "70px",
        paddingLeft: "30px",
        paddingRight:"30px",
        backgroundColor: "#ffffff"
    },
    input: {
        ...defaultFont,
        color: "#AAAAAA !important",
        fontWeight: "300",
        fontSize: "13px",
        lineHeight: "2",
        maxHeight:"50px",
        borderRadius: "5px 5px 5px 5px",
        boxShadow: "rgba(0, 0, 0, 0.35)",
        margin: "15px auto"
    },
    createButton: {
        marginTop: "20px",
        color: "#FFFFFF",
        textTransform: "none"
    },
    select: {
        margin: "15px auto"
    },
})

const validate = val => {

    const errors ={};

    if(!val.title) {
        errors.title = "Position title is required"
    }

    if(!val.entity) {
        errors.entity = "Entity is required"
    }

    if(!val.department) {
        errors.department = "Department name is required"
    }
    
    if(!val.location) {
        errors.location = "Location is required"
    }

    if(!val.description) {
        errors.description = "Job description is required"
    }

    if(!val.requirements) {
        errors.requirements = "Job requirment is required"
    }

    if(!val.min_salary) {
        errors.min_salary = "Location is required"
    }

    if(!val.max_salary) {
        errors.max_salary = "Location is required"
    }

    if(!val.currency_type) {
        errors.currency_type = "Location is required"
    }

    if(!val.close_date) {
        errors.close_date = "Date is required"
    }

    if(val.contract === "unselected") {
        errors.contract = "Contract is required"
    }

    if(!val.start_date && checkContract(val.contract)) {
        errors.start_date = "Start date is required"
    }

    if(!val.end_date && checkContract(val.contract)) {
        errors.end_date = "End date is required"
    }

    return errors
}

const renderField = ({
    input,
    label,
    style,
    multiline,
    rows,
    type,
    meta: { touched, error, warning }
}) => (
      <div>
        <TextField
          className={style}
          {...input}
          label={label}
          type={type}
          variant="outlined"
          fullWidth
          multiline={multiline}
          rows={rows}
        />
        {touched &&
          ((error && <span style={{ color: "red" }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
);

const renderSelect = ({style, input, label, label_width, meta: { touched, error, warning}, children, ...custom}) => (

    <FormControl 
        fullWidth
        variant="outlined" 
        className={style} 
        error={touched && error}
        >
            <InputLabel htmlFor="single-selected">{label}</InputLabel>
            <Select
                fullWidth
                variant="outlined"
                placeholder="label"
                label={label}
                input={
                    <OutlinedInput 
                        id="single-selected" 
                        labelWidth={label_width}/>
                }
                {...input}
                {...custom}
                inputProps={{
                    name: 'category',
                    id: 'job-category'
                }}
            >
                {children}
            </Select> 
          {
             touched &&
             ((error && <span style={{ color: "red" }}>{error}</span>) ||
               (warning && <span>{warning}</span>))
          }
        
    </FormControl>
)

// const renderEditor = ({style, input, label, meta: {touched, error, warning} }) => (
//     <div>
//         <YomaEditor
//             className={style} 
//             placeholder={label}
//             value={input.value} 
//             onChange={(value) => 
//                 input.onChange(stateToHTML(value))
//             } 
//         />
//         {
//              touched &&
//              ((error && <span style={{ color: "red" }}>{error}</span>) ||
//                (warning && <span>{warning}</span>))
//         }
//     </div>
    
// )

export const renderDatePicker = ({style, input, label, placeholder, meta: { touched, error, warning}, ...custom}) => (
    <div>
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <InlineDatePicker
                    className={style}
                    keyboard
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label={label}
                    minDate={new Date()}
                    placeholder={placeholder}
                    value={input.value}
                    error = {touched && error}
                    format={"YYYY-MM-DD"}
                    mask={[/\d/, /\d/, /\d/, /\d/,'-',/\d/, /\d/, '-', /\d/, /\d/ ]}
                    onChange={input.onChange}
                    {...input}
                    {...custom}
                />
        </MuiPickersUtilsProvider>

        {
             touched &&
             ((error && <span style={{ color: "red" }}>{error}</span>) ||
               (warning && <span>{warning}</span>))
        }
        
    </div>
    
)

export const renderRadioGroup = ({style, input, label, meta: { touched, error, warning}, children,
    ...rest}) => (
    <FormControl 
        fullWidth
        variant="outlined" 
        className={style} 
        error={touched && error}
        >
        <FormLabel >
            {
                label
            }
        </FormLabel>

        <RadioGroup
            {...input}
            {...rest}
            valueselected={input.value}
            onChange={(value) => input.onChange(value)}
            row
            >
                {children}
        </RadioGroup>

        {
            touched &&
            ((error && <span style={{ color: "red" }}>{error}</span>) ||
            (warning && <span>{warning}</span>))
        }

    </FormControl>
)

function checkContract(contract) {

    if(contract === 'unselected') {
        return false
    } else if(contract === 'full') {
        return false
    }else {
        return true
    }
}


CreateJobForm = reduxForm({
    form: 'create_job',
    validate,
    initialValues: {
        category: [],
        benefits: [],
        contract: "unselected"
    }
})(withStyles(styles)(CreateJobForm))

export default CreateJobForm


